import React, { useCallback, useEffect, useState } from "react";
import "../assets/packages/leaflet/leaflet.css";
import "../assets/packages/leaflet/leaflet-search.css";
import "../assets/packages/leaflet/L.Control.Locate.min.css";

const MyMap = (props) => {
    const { lat, lng, setLat, setLng, polygon } = props;
    const [userlat] = useState(lat);
    const [userlng] = useState(lng);
    const [mapState, setMapState] = useState();

    const showMap = useCallback(
        (userlat, userlang) => {
            if (mapState) {
                mapState.remove();
            }
            const L = window.L;
            const icon = L.icon({
                iconUrl: "leaflet/images/marker-icon.png",
                iconSize: [24, 36],
                iconAnchor: [14, 36],
                shadowUrl: "leaflet/images/marker-shadow.png",
                shadowSize: [40, 46],
                shadowAnchor: [14, 48],
            });
            let TEHRAN = [35.6997, 51.3374];

            // let isIntersectPoint = false;

            function initMap(map, location, accuracy, isFound) {
                setMapState(map);
                let point = TEHRAN;
                if (isFound) {
                    point = location;
                }
                point =
                    userlat !== null && userlang !== null
                        ? [userlat, userlang]
                        : point;

                let marker = L.marker(point, {
                    draggable: true,
                    autoPan: true,
                    icon: icon,
                }).bindPopup("موقعیت شما روی نقشه :)");
                // let circle = L.circle(point, accuracy, {
                //     weight: 1,
                //     color: '#ff5e00',
                //     fillColor: '#ff5e00',
                //     fillOpacity: 0.2
                // });
                // map.addLayer(circle);
                map.addLayer(marker);
                let polygonPoints = polygon;

                let poly = L.polygon(polygonPoints).addTo(map);
                map.fitBounds(poly.getBounds());

                // isIntersectPoint = isIntersect([LAT, LONG], polygonPoints);

                marker.on("dragend", function () {
                    // isIntersectPoint = isIntersect([marker.getLatLng().lat, marker.getLatLng().lng], polygonPoints);

                    setLat(marker.getLatLng().lat);
                    setLng(marker.getLatLng().lng);

                    // if (!isIntersectPoint){
                    //     console.log("not inside")
                    // }
                });

                map.on("click", function (event) {
                    marker.setLatLng(event.latlng);
                    marker.addTo(map);

                    // isIntersectPoint = isIntersect([marker.getLatLng().lat, marker.getLatLng().lng], polygonPoints);

                    setLat(marker.getLatLng().lat);
                    setLng(marker.getLatLng().lng);

                    // if (!isIntersectPoint){
                    //     console.log("not inside")
                    // }
                });
                let latLngs = [marker.getLatLng()];
                let markerBounds = L.latLngBounds(latLngs);
                map.fitBounds(markerBounds);
                map.setZoom(16);
                map.addControl(
                    new L.Control.Search({
                        url: "https://nominatim.openstreetmap.org/search?format=json&q={s}",
                        jsonpParam: "json_callback",
                        propertyName: "display_name",
                        propertyLoc: ["lat", "lon"],
                        marker: L.circleMarker([0, 0], { radius: 30 }),
                        autoCollapse: false,
                        autoType: false,
                        minLength: 2,
                    }),
                );
            }

            // function isIntersect(point, vs) {
            //     let x = point[0], y = point[1];
            //
            //     let inside = false;
            //     for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            //         let xi = vs[i][0], yi = vs[i][1];
            //         let xj = vs[j][0], yj = vs[j][1];
            //
            //         let intersect = ((yi > y) !== (yj > y))
            //             && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            //         if (intersect) inside = !inside;
            //     }
            //
            //     return inside;
            // }
            let map;
            let loadMap = function (id) {
                map = L.map(id);
                // let tile_url = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png';
                let tile_url =
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
                let layer = L.tileLayer(tile_url, {
                    attribution: "",
                });
                map.addLayer(layer);
                map.setView(TEHRAN, 19);

                let canLocate = false;
                navigator.geolocation.getCurrentPosition(
                    function () {
                        canLocate = true;
                    },
                    function () {
                        canLocate = false;
                    },
                    {
                        timeout: 1000 * 60,
                        enableHighAccuracy: true,
                        maximumAge: 1000 * 60 * 60,
                    },
                );

                if (canLocate) {
                    map.locate({
                        watch: true,
                    }) /* This will return map so you can do chaining */
                        .on("locationfound", function (e) {
                            initMap(
                                map,
                                [e.latitude, e.longitude],
                                e.accuracy / 2,
                                true,
                            );
                        })
                        .on("locationerror", function (e) {
                            initMap(
                                map,
                                [e.latitude, e.longitude],
                                e.accuracy / 2,
                                false,
                            );
                            console.log(e);
                        });
                } else {
                    initMap(map, TEHRAN, 1 / 2, false);
                }
                L.control.locate().addTo(map);
            };

            loadMap("map");
        },
        [setLat, setLng, polygon],
    );

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "/user/leaflet/leaflet.js";
        document.body.appendChild(script);

        script.onload = () => {
            const script2 = document.createElement("script");
            script2.src =
                "https://cdn.jsdelivr.net/npm/leaflet.locatecontrol/dist/L.Control.Locate.min.js";
            document.body.appendChild(script2);

            script2.onload = () => {
                const script3 = document.createElement("script");
                script3.src =
                    "https://honari.com/themes/bmr/outsource/leaflet/leaflet-search.js";
                document.body.appendChild(script3);

                script3.onload = () => {
                    showMap(userlat, userlng);
                };
            };
        };
    }, [userlat, userlng, showMap]);

    return <div id="map" style={{ width: "100%", height: "100%" }} />;
};
export default MyMap;
